export default __webpack_public_path__ + "static/media/VC.42390e0e.svg";